const { getElement, getElements } = window.PURELEI.Utils

export class SiteDrawers extends window.PURELEI.CustomElement() {
    constructor () {
        super()

        if (this.hasAlreadyBeenUsed) {
            throw new Error(
                `You can only use 1 instance of ${this.nodeName.toLowerCase()}`,
            )
        }

        this._activeDrawerKey = ''
        this.drawers = []

        window.drawers = this

        this.drawerKeys
            .filter((key) => !this.triggerKeys.includes(key))
            .forEach((key) =>
                console.info(`Drawer exists for ${key} but there is no trigger`),
            )
    }

    setupListeners () {
        super.setupListeners()

        this.listeners.add(
            document.documentElement,
            'click',
            this.handleClick.bind(this),
        )

        window.PURELEI.eventBus.addEventListener(window.PURELEI.EVENTS.DRAWER.OPEN, (e) => {
            if (e.detail.key === 'menu') {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'nav_burger_menu',
                        state: 'open',
                    })
                }
            }
        })

        window.PURELEI.eventBus.addEventListener(window.PURELEI.EVENTS.DRAWER.OPEN, (e) => {
            const key = e.detail?.key
            if (key) {
                this.activeDrawerKey = key
            }
        })
    }

    handleClick (e) {
        const EVENTS = {
            TRIGGER: 'TRIGGER',
            CLOSE: 'CLOSE',
            BACKDROP: 'BACKDROP',
            UNKNOWN: 'UNKNOWN',
        }
        const eventType = (() => {
            if (e.target.closest(this.config.matches.trigger) !== null) {
                return EVENTS.TRIGGER
            } else if (e.target.closest(this.config.matches.close) !== null) {
                return EVENTS.CLOSE
            } else if (e.target.closest(this.config.matches.backdrop) !== null) {
                return EVENTS.BACKDROP
            }

            return EVENTS.UNKNOWN
        })()

        if (eventType === EVENTS.UNKNOWN) return
        e.preventDefault()

        if (eventType === EVENTS.TRIGGER) {
            const trigger = e.target.closest(this.config.matches.trigger)
            const key = trigger.getAttribute('data-drawers-trigger')

            this.activeDrawerKey = key === this.activeDrawerKey ? '' : key

            window.PURELEI.dispatchEvent(
                this.activeDrawerKey
                    ? window.PURELEI.EVENTS.DRAWER.OPEN
                    : window.PURELEI.EVENTS.DRAWER.CLOSE,
                {
                    key,
                },
            )
        }

        if (eventType === EVENTS.CLOSE || eventType === EVENTS.BACKDROP) {
            window.PURELEI.dispatchEvent(window.PURELEI.EVENTS.DRAWER.CLOSE, {
                key: this.activeDrawerKey,
            })
            this.activeDrawerKey = ''
        }
    }

    /**
     * @param {string} key
     */
    open (key) {
        window.PURELEI.dispatchEvent(window.PURELEI.EVENTS.DRAWER.OPEN, {
            key,
        })
        this.activeDrawerKey = key
    }

    close () {
        window.PURELEI.dispatchEvent(window.PURELEI.EVENTS.DRAWER.CLOSE, {
            key: this.activeDrawerKey,
        })
        this.activeDrawerKey = ''
    }

    get triggerKeys () {
        return getElements('[data-drawers-trigger]').map((el) =>
            el.getAttribute('data-drawers-trigger'),
        )
    }

    get drawerKeys () {
        return getElements('[data-module-drawers-drawer]').map((el) =>
            el.getAttribute('data-module-drawers-drawer'),
        )
    }

    get hasAlreadyBeenUsed () {
        const el = getElement(this.nodeName.toLowerCase())

        return el !== this
    }

    get aDrawerIsOpen () {
        return this.drawers.some((drawer) => drawer.isOpen)
    }

    get activeDrawerKey () {
        return this._activeDrawerKey
    }

    set activeDrawerKey (key) {
        this._activeDrawerKey = key

        this.drawers.forEach((drawer) => (drawer.isOpen = drawer.key === key))

        this.config.elements.drawers.classList.toggle(
            this.config.classes.activeClass,
            this.aDrawerIsOpen,
        )
        document.body.classList.toggle(
            this.config.classes.siteOverflowed,
            this.aDrawerIsOpen,
        )
        document.body.classList.toggle(
            this.config.classes.drawersOpenUtility,
            this.aDrawerIsOpen,
        )

        if (key !== '') {
            this.els.drawer.element.classList.add('drw-Drawers_Drawer-active')
            document.body.classList.add(`drw-Drawers-${key}`)
        } else {
            this.els.drawer.element.classList.remove('drw-Drawers_Drawer-active')
        }
    }

    get config () {
        return {
            matches: {
                trigger: '[data-drawers-trigger]',
                subNav: '[data-drawers-sub-nav]',
                back: '[data-drawers-back]',
                close: '[data-drawers-close]',
                backdrop: '[data-site-drawers-el="backdrop"]',
            },
            classes: {
                activeClass: 'drw-Drawers-active',
                activeDrawerClass: 'drw-Drawer-active',
                siteOverflowed: 'util-SiteOverflowed',
                drawersOpenUtility: 'util-DrawersOpen',
            },
            elements: {
                body: document.body || document.documentElement,
                backdrop: '[data-site-drawers-el="backdrop"]',
                drawers: document.querySelector('site-drawers'),
            },
        }
    }
}

customElements.define('site-drawers', SiteDrawers)
